import { getValue } from "@utils/lodash";
import { toast } from "react-toastify";
import { Nav, NavItem, NavLink } from "reactstrap";

function NavViews(props: any) {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const urlParams = Object.fromEntries(urlSearchParams.entries());

  return (
    <div className="d-flex" style={{ width: "100%" }}>
      <Nav tabs className="navbar_policy">
        {getValue(props, `views.length`, 0) > 0
          ? getValue(props, `views`, []).map((item: object, index: number) => {
              const hasSavedField =
                getValue(urlParams, `field_id`, "") ||
                getValue(props, `params.id`, "");
              const needsSavedParent =
                getValue(item, `name`, "") === "Table Fields" &&
                !hasSavedField;

              return (
                <NavItem className="navitem_policy" key={getValue(item, `name`, index)}>
                  <NavLink
                    disabled={Boolean(needsSavedParent)}
                    className={`navlink_policy ${
                      getValue(props, `activeTab`, "") === index + 1
                        ? "active"
                        : ""
                    }`}
                    onClick={() => {
                      if (needsSavedParent) {
                        toast.error(
                          "Save this table field before adding columns."
                        );
                        return;
                      }
                      if (hasSavedField) {
                        props.handleChangeActiveTab(index + 1);
                      } else {
                        toast.error("Please add custom field to continue!");
                      }
                    }}
                  >
                    <p>{getValue(item, `name`, "")}</p>
                  </NavLink>
                </NavItem>
              );
            })
          : null}
      </Nav>
    </div>
  );
}

export default NavViews;
